export default __webpack_public_path__ + "static/media/luv.476e6077.png";